import './OkulyonetimProductDetail.scss'

import { FilePdfOutlined, HeartFilled, HeartOutlined} from '@ant-design/icons'
import {ShoppingCartOutlined} from '@ant-design/icons/lib/icons'
import {Col, notification, Row, Tooltip} from 'antd'
import kitapimg from 'images/okulyonetim/okulyonetim_image1.jpg'
import React, {useContext, useEffect, useRef, useState} from 'react'
import {useNavigate} from 'react-router-dom'

import AppContext from '../../../context/AppContext'
import {
    OkulYonetimUrunFiltre,
    useFavoriEkleMutation,
    useOkulyonetimurunQuery,
    useSinifaUrunEkleMutation,
} from '../../../gql/GeneratedGraphqlTypes'
import {getFormattedPrice} from "../../../helpers/Formatting";
import Spinner from '../../spinner/Spinner'
import OkulyonetimAddToClassModal from '../okulyonetim-add-to-class-modal/OkulyonetimAddToClassModal'
import OkultonetimSuccessModal from '../okulyonetim-added-product-model/OkulyonetimSuccessModal'
import {OkulyonetimProductType} from '../okulyonetim-product/type'

const OkulyonetimProductDetail: React.FC<OkulyonetimProductType> = (props) => {
    const { onFavoriteChange} = props
    const {slug} = useContext(AppContext)
    const [favoriEkleMutation] = useFavoriEkleMutation()
    const [isModalOpen, setIsModalOpen] = useState(false)
    const imageRef = useRef<HTMLDivElement>(null)
    const navigate = useNavigate()
    const [sinifaUrunEkleMutation] = useSinifaUrunEkleMutation()
    const [selectedItems, setSelectedItems] = useState<{ sinifId: number; sinifDersId: number }[]>([])
    const [successMessage, setSuccessMessage] = useState('')
    const [returnedDersler, setReturnedDersler] = useState<string[]>([])
    const [successModalVisible, setSuccessModalVisible] = useState(false)
    const [inputValue, setInputValue] = useState<number | null>(1);
    const getLastSlugPart = (): string | undefined => {
        const pathname = window.location.pathname
        const slugPart = pathname.split('/').pop()
        return slugPart
    }
    const lastSlugPart = getLastSlugPart()
    const [filters, setFilters] = useState<OkulYonetimUrunFiltre>({
        urunId: lastSlugPart ? parseInt(lastSlugPart) : 0,
    })
    const {data, loading, error, refetch} = useOkulyonetimurunQuery({
        variables: {
            slug: slug!,
            filtre: filters,
        },
    })
    useEffect(() => {
        if (lastSlugPart) {
            setFilters({
                urunId: parseInt(lastSlugPart),
            })
        }
    }, [lastSlugPart])

    useEffect(() => {
        if (filters) {
            refetch({filtre: filters})
        }
    }, [filters, refetch])

    useEffect(() => {
        if (error) {
            console.error(error)
            navigate('/')
        }
    }, [error, navigate])

    if (loading) {
        return <Spinner showSpinner={loading} color="red"/>
    }
    const handleMouseEnter = () => {
        const elem = imageRef.current
        if (elem) {
            const size = elem.getBoundingClientRect()

            elem.dataset.x = size.x.toString()
            elem.dataset.y = size.y.toString()
            elem.dataset.width = size.width.toString()
            elem.dataset.height = size.height.toString()
        }
    }

    const handleMouseMove = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        const elem = imageRef.current
        if (elem) {
            const x = parseFloat(elem.dataset.x || '0')
            const y = parseFloat(elem.dataset.y || '0')
            const width = parseFloat(elem.dataset.width || '0')
            const height = parseFloat(elem.dataset.height || '0')

            const horizontal = ((e.clientX - x) / width) * 100
            const vertical = ((e.clientY - y) / height) * 100

            elem.style.setProperty('--x', `${horizontal}%`)
            elem.style.setProperty('--y', `${vertical}%`)
        }
    }

    const showModal = () => {
        setIsModalOpen(true)
    }

    const handleOk = async (selectedItems: { sinifId: number; sinifDersId: number }[]) => {
        const dersler = selectedItems.map((item) => item.sinifDersId)
        try {
            const response = await sinifaUrunEkleMutation({
                variables: {
                    input: {
                        urun_id: parseInt(lastSlugPart!),
                        adet: inputValue!,
                        dersler: dersler,
                    },
                },
            })
            if (response.data?.sinifaUrunEkle?.success) {
                setIsModalOpen(false)
                setSuccessMessage(response.data.sinifaUrunEkle.message || 'İşlem başarılı')

                const derslerListesi = (response.data.sinifaUrunEkle.dersler || []).filter(
                    (ders): ders is string => ders !== null,
                )

                setReturnedDersler(derslerListesi)
                setSuccessModalVisible(true)
                setSelectedItems([])
            } else {
                setIsModalOpen(false)
                notification.success({
                    message: '',
                    description: `${response.data?.sinifaUrunEkle?.message}`,
                    duration: 6,
                })
            }
        } catch (error) {
            // Hata mesajı göster
            notification.success({
                message: '',
                description: `'Ürün güncellenirken bir hata oluştu.'.`,
                duration: 6,
            })
        }
    }
    const handleCancel = () => {
        setIsModalOpen(false)
    }
    const handleFavorite = async () => {
        try {
            const response = await favoriEkleMutation({
                variables: {
                    input: {
                        urun_id: parseInt(lastSlugPart!),
                    },
                },
            })
            if (response.data?.favoriEkle.success) {
                notification.success({
                    message: '',
                    description: `${response.data?.favoriEkle?.message}`,
                    duration: 6,
                })
                if (onFavoriteChange) {
                    onFavoriteChange() // Favori değişikliğinden sonra tetikle
                }
                refetch()
            } else {
                notification.error({
                    message: '',
                    description: `${response.data?.favoriEkle?.message || 'Bir hata oluştu'}`,
                    duration: 6,
                })
            }
        } catch (error) {
            // Hata mesajı göster
            notification.error({
                message: '',
                description: `'Favori işlemi sırasında bir hata oluştu.'.`,
                duration: 6,
            })
        }
    }
    return (
        <div className="db-okulyonetim-product-detail">
            <Row className="okulyonetim-product-detail-row" gutter={24}>
                <Col xs={24} md={12}>
                    <div
                        className="okulyonetim-product-detail-row-image"
                        ref={imageRef}
                        onMouseEnter={handleMouseEnter}
                        onMouseMove={handleMouseMove}
                    >
                        <img
                            src={
                                data?.okul?.okulyonetimUrunler?.okulyonetim_urunler?.[0]?.urun?.resim
                                    ? data?.okul?.okulyonetimUrunler?.okulyonetim_urunler?.[0]?.urun?.resim
                                    : data?.okul?.okulyonetimUrunler?.okulyonetim_urunler?.[0]?.urun?.resim_url
                                        ? data?.okul?.okulyonetimUrunler?.okulyonetim_urunler?.[0]?.urun?.resim_url
                                        : kitapimg
                            }
                            alt=""
                        />
                    </div>
                </Col>
                <Col xs={24} md={12}>
                    <div className="okulyonetim-product-detail-row-info">
                        <div className="okulyonetim-product-detail-row-info-title">
                            {data?.okul?.okulyonetimUrunler?.okulyonetim_urunler?.[0]?.urun?.isim
                                ? data?.okul?.okulyonetimUrunler?.okulyonetim_urunler?.[0]?.urun?.isim
                                : '1000 Basic English Words 1 with CD Collins'}
                        </div>
                        <div className="okulyonetim-product-detail-row-info-title1">
                            {data?.okul?.okulyonetimUrunler?.okulyonetim_urunler?.[0]?.urun?.aciklama
                                ? data?.okul?.okulyonetimUrunler?.okulyonetim_urunler?.[0]?.urun?.aciklama
                                : ''}
                        </div>
                        <div className="okulyonetim-product-detail-row-info-descriptions">
                            <div>
                                <span>Sınıf:</span>
                                {data?.okul?.okulyonetimUrunler?.okulyonetim_urunler?.[0]?.urun?.sinif
                                    ? data?.okul?.okulyonetimUrunler?.okulyonetim_urunler?.[0]?.urun?.sinif
                                    : ''}
                            </div>
                            <div>
                                <span>Barkod:</span>
                                {data?.okul?.okulyonetimUrunler?.okulyonetim_urunler?.[0]?.urun?.barkod
                                    ? data?.okul?.okulyonetimUrunler?.okulyonetim_urunler?.[0]?.urun?.barkod
                                    : ''}
                            </div>
                            <div>
                                <span>Yayınevi:</span>
                                {data?.okul?.okulyonetimUrunler?.okulyonetim_urunler?.[0]?.urun?.yayinevi
                                    ? data?.okul?.okulyonetimUrunler?.okulyonetim_urunler?.[0]?.urun?.yayinevi
                                    : ''}
                            </div>
                        </div>
                        <div className="okulyonetim-product-detail-row-info-add">
                            <div className="okulyonetim-product-detail-row-info-add-price">
                                {data?.okul?.okulyonetimUrunler?.okulyonetim_urunler?.[0]?.urun?.etiket_fiyati
                                    ? data?.okul?.okulyonetimUrunler?.okulyonetim_urunler?.[0]?.urun?.etiket_fiyati <= 0.1 ? 'Ürün fiyatı belli değil' :
                                        <span>{getFormattedPrice(data?.okul?.okulyonetimUrunler?.okulyonetim_urunler?.[0]?.urun?.etiket_fiyati?.toString())} TL</span>
                                    : ''}
                            </div>
                            <div className="okulyonetim-product-detail-row-info-add-buttons">
                                <div className="okulyonetim-product-detail-row-info-add-buttons-basket"
                                     onClick={showModal}>
                                    <ShoppingCartOutlined/>
                                    <span id="add-to-class">Sınıfa Ekle</span>
                                </div>
                                <div className="okulyonetim-product-detail-row-info-add-buttons-favorite"
                                     onClick={handleFavorite}>
                                    {data?.okul?.okulyonetimUrunler?.okulyonetim_urunler?.[0]?.urun?.is_favori ?
                                        <HeartFilled/> : <HeartOutlined/>}
                                </div>
                                <div className="okulyonetim-product-detail-row-info-add-buttons-download">
                                    {data?.okul?.okulyonetimUrunler?.okulyonetim_urunler?.[0]?.urun?.pdf_url && (
                                        <Tooltip placement="bottom">
                                            <div
                                                className="okulyonetim-product-detail-row-info-add-buttons-download-excel"
                                                onClick={() => window.open(data?.okul?.okulyonetimUrunler?.okulyonetim_urunler?.[0]?.urun?.pdf_url!, '_blank', 'noopener,noreferrer')}
                                            >
                                                <FilePdfOutlined/>
                                            </div>
                                        </Tooltip>
                                    )}
                                    {data?.okul?.okulyonetimUrunler?.okulyonetim_urunler?.[0]?.urun?.pdf && (
                                        <Tooltip placement="bottom">
                                            <div
                                                className="okulyonetim-product-detail-row-info-add-buttons-download-pdf"
                                                onClick={() => {
                                                    const link = document.createElement('a');
                                                    link.href = data?.okul?.okulyonetimUrunler?.okulyonetim_urunler?.[0]?.urun?.pdf!;
                                                    link.download = data?.okul?.okulyonetimUrunler?.okulyonetim_urunler?.[0]?.urun?.pdf!.split('/').pop() || 'file.pdf'; // Dosya adını belirleme
                                                    link.target = '_blank';
                                                    document.body.appendChild(link);
                                                    link.click();
                                                    document.body.removeChild(link); // Temizlik işlemi
                                                }}
                                            >
                                                <FilePdfOutlined/>
                                            </div>
                                        </Tooltip>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>
            <OkulyonetimAddToClassModal
                image={
                    data?.okul?.okulyonetimUrunler?.okulyonetim_urunler?.[0]?.urun?.resim
                        ? data?.okul?.okulyonetimUrunler?.okulyonetim_urunler?.[0]?.urun?.resim
                        : data?.okul?.okulyonetimUrunler?.okulyonetim_urunler?.[0]?.urun?.resim_url
                            ? data?.okul?.okulyonetimUrunler?.okulyonetim_urunler?.[0]?.urun?.resim_url
                            : kitapimg
                }
                title={data?.okul?.okulyonetimUrunler?.okulyonetim_urunler?.[0]?.urun?.isim!}
                price={data?.okul?.okulyonetimUrunler?.okulyonetim_urunler?.[0]?.urun?.etiket_fiyati!}
                selectedItems={selectedItems}
                setSelectedItems={setSelectedItems}
                quantity={inputValue!}
                setInputValue={setInputValue}
                inputValue={inputValue}
                isModalOpen={isModalOpen}
                handleOk={handleOk}
                handleCancel={handleCancel}
            />
            <OkultonetimSuccessModal
                image={data?.okul?.okulyonetimUrunler?.okulyonetim_urunler?.[0]?.urun?.resim
                    ? data?.okul?.okulyonetimUrunler?.okulyonetim_urunler?.[0]?.urun?.resim
                    : data?.okul?.okulyonetimUrunler?.okulyonetim_urunler?.[0]?.urun?.resim_url
                        ? data?.okul?.okulyonetimUrunler?.okulyonetim_urunler?.[0]?.urun?.resim_url
                        : kitapimg}
                title={data?.okul?.okulyonetimUrunler?.okulyonetim_urunler?.[0]?.urun?.isim!}
                price={data?.okul?.okulyonetimUrunler?.okulyonetim_urunler?.[0]?.urun?.etiket_fiyati!}
                quantity={1}
                isModalVisible={successModalVisible}
                message={successMessage}
                dersler={returnedDersler}
                handleOk={() => setSuccessModalVisible(false)}
            />
        </div>
    )
}

export default OkulyonetimProductDetail
